import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import AuthModal from '../components/AuthModal';
import AnnouncementsSection from '../components/AnnouncementsSection';

export default function LandingPage({ user, onLogin, onShowTerms, onShowPrivacy }) {
  const navigate = useNavigate();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [email, setEmail] = useState('');
  const [emailStatus, setEmailStatus] = useState(null);
  const [preRegEmail, setPreRegEmail] = useState('');
  const [preRegUsername, setPreRegUsername] = useState('');
  const [preRegPassword, setPreRegPassword] = useState('');
  const [preRegStatus, setPreRegStatus] = useState(null);
  const [preRegLoading, setPreRegLoading] = useState(false);

  // ── Odczyt kodu referralowego z URL (?ref=KOD) ───────────────────────────
  const [searchParams] = useSearchParams();
  const refCode = new URLSearchParams(window.location.search).get('ref') ?? '';
  const openAuth = searchParams.get('openAuth') === '1';

  useEffect(() => {
    if (refCode || openAuth) setShowAuth(true);
  }, [refCode, openAuth]);

  // ── Jeśli wchodzi z linka ref → automatycznie otwórz modal rejestracji ───
  useEffect(() => {
    if (refCode) setShowAuth(true);
  }, [refCode]);

  const appScreens = [
    '/assests/load.jpg',
    '/assests/commu.jpg',
    '/assests/prof.jpg',
    '/assests/welcom.jpg',
    '/assests/spots.jpg',
  ];

  useEffect(() => {
    const id = setInterval(() => setCurrentSlide((p) => (p + 1) % appScreens.length), 3000);
    return () => clearInterval(id);
  }, []);

  const handleLoginSuccess = (userData) => {
    onLogin(userData);
    navigate('/profile');
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://v-room.app/sapi/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (data.success) {
        setEmailStatus({
          type: 'success',
          message: data.message || 'Dziękujemy! Sprawdź swoją skrzynkę.',
        });
        setEmail('');
        setTimeout(() => setEmailStatus(null), 5000);
      } else {
        setEmailStatus({ type: 'error', message: data.message || 'Coś poszło nie tak' });
      }
    } catch {
      setEmailStatus({ type: 'error', message: 'Błąd połączenia z serwerem' });
    }
  };

  const handlePreRegister = async (e) => {
    e.preventDefault();
    if (preRegPassword.length < 6) {
      setPreRegStatus({ type: 'error', message: 'Hasło musi mieć min. 6 znaków' });
      return;
    }
    setPreRegLoading(true);
    try {
      const res = await fetch('https://v-room.app/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: preRegEmail.trim(),
          username: preRegUsername.trim(),
          password: preRegPassword,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setPreRegStatus({
          type: 'success',
          message: '🎉 Konto utworzone! Zaloguj sie aby zobaczyć profil.',
        });
        setPreRegEmail('');
        setPreRegUsername('');
        setPreRegPassword('');
      } else {
        setPreRegStatus({ type: 'error', message: data.error || 'Coś poszło nie tak' });
      }
    } catch {
      setPreRegStatus({ type: 'error', message: 'Błąd połączenia z serwerem' });
    } finally {
      setPreRegLoading(false);
      setTimeout(() => setPreRegStatus(null), 6000);
    }
  };

  return (
    <div className="vroom-landing">
      <div className="bg-grid-overlay"></div>

      {/* Floating login */}
      <button className="floating-login-btn" onClick={() => setShowAuth(true)}>
        <span className="material-icons">login</span>
        Zaloguj sie
      </button>

      {/* NAVBAR */}
      <nav className="navbar">
        <div className="logo">
          <span className="material-icons">speed</span>
          VROOM<span className="dot">.</span>APP
        </div>
        <button className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen((o) => !o)}>
          <span />
          <span />
          <span />
        </button>
        <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <a href="#about" onClick={() => setMenuOpen(false)}>
            O NAS
          </a>
          <a href="#features" onClick={() => setMenuOpen(false)}>
            FUNKCJE
          </a>
          <a href="#ranking" onClick={() => setMenuOpen(false)}>
            RANKING
          </a>
          <a href="#news" onClick={() => setMenuOpen(false)}>
            AKTUALNOŚCI
          </a>
          <a href="#support" onClick={() => setMenuOpen(false)}>
            WESPRZYJ NAS
          </a>
          <a href="#REGGGG">
            <button className="btn-download" onClick={() => setMenuOpen(false)}>
              Stwórz konto!
            </button>
          </a>
        </div>
      </nav>

      {/* HERO */}
      <header className="hero">
        <div className="hero-content">
          <div className="badge-glow">V. 1.0 IS IN PROGRESS</div>
          <h1>
            POCZUJ <span>ADRENALINĘ</span>
            <br />
            NA KAŻDYM KILOMETRZE
            <br />
            <span>VROOM</span>
          </h1>
          <p>
            Najbardziej zaawansowany ekosystem dla pasjonatów motoryzacji. Monitoruj osiągi, odblokowywuj
            miasta i dominuj w rankingach, pokaż swój garaż.
          </p>
          <div className="hero-btns">
            <button className="btn-primary-glow">
              <a href="https://discord.gg/Uxnr8GyjkK" style={{ textDecoration: 'none', color: '#e7e7e7' }}>
                Discord
              </a>
            </button>
            <a href="#features" className="btn-glass">
              POZNAJ APLIKACJE
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div className="floating-phone">
            <div className="phone-main countdown-box">

              {/* ── POBIERZ APLIKACJĘ ── */}
              <div className="countdown-label">
                <span className="material-icons">download</span>
                POBIERZ APLIKACJĘ
              </div>

              {/* Ostrzeżenie o beta testach */}
              <div className="beta-cta-warn" style={{ marginBottom: 16 }}>
                ⚠️ Aby aplikacja była widoczna w sklepie, musisz być zapisany na listę beta testów.
                Bez tego nie pobierzesz jej ze sklepu Play.
              </div>

              {/* Instrukcja */}
              <div className="beta-cta-how" style={{ marginBottom: 20 }}>
                Jak dołączyć do beta testów:
                <ol>
                  <li>Zaloguj się na stronie</li>
                  <li>
                    Wejdź w zakładkę <b>BetaTesty</b>
                  </li>
                  <li>Zapisz się na listę</li>
                </ol>
              </div>

              {/* Przycisk logowania */}
              <button
                className="btn-primary-glow"
                onClick={() => setShowAuth(true)}
                type="button"
                style={{ width: '100%', marginBottom: 20 }}
              >
                <span className="material-icons" style={{ verticalAlign: 'middle', marginRight: 6 }}>login</span>
                Zaloguj się
              </button>

              {/* Google Play */}
              <a
                href="https://play.google.com/store/apps/details?id=com.lexuuw.vroom.app"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', marginBottom: 12 }}
              >
                <img
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/pl_badge_web_generic.png"
                  alt="Pobierz z Google Play"
                  style={{ height: 54, width: 'auto', display: 'block', margin: '0 auto' }}
                />
              </a>

              {/* App Store — oczekiwanie */}
              <div className="ios-coming-soon" style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 10,
                padding: '10px 14px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 10,
                fontSize: '0.8rem',
                color: '#b0b0b0',
                marginTop: 4,
              }}>
                <span className="material-icons" style={{ fontSize: 18, marginTop: 1, color: '#888' }}>schedule</span>
                <span>
                  <b style={{ color: '#ddd' }}>App Store (iOS)</b> — dostępne w ciągu 24h.
                  Oczekujemy na odpowiedź od Apple. To nie jest po naszej stronie.
                </span>
              </div>

            </div>
          </div>
        </div>
      </header>

      {/* ABOUT */}
      <section id="about" className="about-section">
        <div className="section-title">
          <h2>
            TROCHĘ O <span>VROOM</span>
          </h2>
        </div>
        <div className="about-grid">
          {[
            {
              icon: 'free_cancellation',
              title: '100% DARMOWA',
              desc: 'Bez żadnych opłat, bez ukrytych kosztów. Pobierz i korzystaj natychmiast.',
            },
            {
              icon: 'security',
              title: 'BEZPIECZNA',
              desc: 'Twoje dane chronione. Dbamy o to abyś zawsze czuł się bezpiecznie.',
            },
            {
              icon: 'update',
              title: 'ZAWSZE AKTUALNA',
              desc: 'Ostrzeżenia o patrolach od innych użytkowników w czasie rzeczywistym.',
            },
          ].map((c) => (
            <div key={c.title} className="about-card">
              <span className="material-icons about-icon">{c.icon}</span>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* YT VIDEO SECTION */}
      <section className="yt-section">
        <div className="yt-container">
          <div className="section-title" style={{ marginBottom: 0 }}>
            <h2>
              POZNAJ <span>PROJEKT</span>
            </h2>
            <p>Zobacz co przygotowaliśmy dla pasjonatów motoryzacji</p>
          </div>
          <div className="yt-frame-wrap">
            <iframe
              src="https://www.youtube.com/embed/IRzoMVlVwUU?si=wKykBq8Zf-o6dbzU"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <AnnouncementsSection />

      {/* PRE-REGISTRATION */}
      <section className="prereg-section" id="REGGGG">
        <div className="prereg-container">
          <div className="prereg-left">
            <div className="badge-glow" style={{ marginBottom: 16 }}>
              EARLY ACCESS
            </div>
            <h2>
              ZAŁÓŻ KONTO <span>JUŻ TERAZ</span>
            </h2>
            <p>Zarejestruj się przed premierą i bądź gotowy od pierwszego dnia.</p>
            <div className="prereg-perks">
              {[
                { icon: 'verified', text: 'Konto gotowe na premierę' },
                { icon: 'emoji_events', text: 'Odznaka Early Adopter' },
                { icon: 'notifications_active', text: 'Powiadomienie o starcie' },
              ].map((p) => (
                <div key={p.icon} className="perk-item">
                  <span className="material-icons">{p.icon}</span>
                  <span>{p.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="prereg-right">
            <form className="prereg-form" onSubmit={handlePreRegister}>
              <div className="prereg-field">
                <label>NAZWA UŻYTKOWNIKA</label>
                <div className="prereg-input-wrap">
                  <span className="material-icons">person</span>
                  <input
                    type="text"
                    placeholder="np. NightRider_PL"
                    value={preRegUsername}
                    onChange={(e) => setPreRegUsername(e.target.value)}
                    maxLength={30}
                    required
                  />
                </div>
              </div>

              <div className="prereg-field">
                <label>ADRES E-MAIL</label>
                <div className="prereg-input-wrap">
                  <span className="material-icons">email</span>
                  <input
                    type="email"
                    placeholder="twoj@email.com"
                    value={preRegEmail}
                    onChange={(e) => setPreRegEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="prereg-field">
                <label>HASŁO</label>
                <div className="prereg-input-wrap">
                  <span className="material-icons">lock</span>
                  <input
                    type="password"
                    placeholder="Min. 6 znaków"
                    value={preRegPassword}
                    onChange={(e) => setPreRegPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>
              </div>

              {preRegStatus && <div className={`prereg-message ${preRegStatus.type}`}>{preRegStatus.message}</div>}

              <button type="submit" className="btn-prereg" disabled={preRegLoading}>
                {preRegLoading ? (
                  <span>REJESTROWANIE...</span>
                ) : (
                  <>
                    <span className="material-icons">rocket_launch</span>ZAREJESTRUJ SIĘ
                  </>
                )}
              </button>

              <p className="prereg-terms">
                Rejestrując się akceptujesz{' '}
                <button type="button" className="link-btn" onClick={onShowTerms}>
                  Regulamin
                </button>{' '}
                i{' '}
                <button type="button" className="link-btn" onClick={onShowPrivacy}>
                  Politykę Prywatności
                </button>{' '}
                VROOM.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* ── WESPRZYJ NAS ──────────────────────────────────────────────────── */}
      <section id="support" className="support-section">
        <div className="section-title">
          <h2>
            WESPRZYJ <span>NAS</span>
          </h2>
          <p>Pomagasz nam rozwijać VROOM i tworzyć coś wyjątkowego dla społeczności motoryzacyjnej</p>
        </div>
        <div className="support-container">
          <div className="support-card">
            <div className="support-icon">
              <span className="material-icons">favorite</span>
            </div>
            <h3>KUP NAM KAWĘ ☕</h3>
            <p>
              VROOM jest i zawsze będzie darmowy. Jeśli chcesz wesprzeć nasz rozwój i pomóc nam pokryć koszty
              serwerów — postaw nam kawę!
            </p>
            <div className="support-perks">
              {[
                { icon: 'rocket_launch', text: 'Szybszy rozwój aplikacji' },
                { icon: 'dns', text: 'Utrzymanie serwerów' },
                { icon: 'favorite', text: 'Wsparcie małego, polskiego projektu' },
              ].map((p) => (
                <div key={p.icon} className="perk-item">
                  <span className="material-icons">{p.icon}</span>
                  <span>{p.text}</span>
                </div>
              ))}
            </div>
            <a
              href="https://buycoffee.to/vroom"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-support"
            >
              <span className="material-icons">coffee</span>
              WESPRZYJ NA BUYCOFFEE.TO
            </a>
          </div>
        </div>
      </section>

      {/* SOCIAL */}
      <section id="social" className="social-media-section">
        <div className="section-title">
          <h2>
            DOŁĄCZ DO <span>NASZEJ SPOŁECZNOŚCI</span>
          </h2>
          <p>Bądź częścią pasjonującej społeczności motoryzacyjnej</p>
        </div>
        <div className="social-container">
          <div className="social-main">
            <div className="discord-card">
              <div className="discord-header">
                <i className="fab fa-discord"></i>
              </div>
              <h3>DISCORD COMMUNITY</h3>
              <p>Dołącz do naszego serwera Discord! Zostań testerem, uczestnicz w eventach i wygrywaj nagrody.</p>
              <div className="discord-stats">
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <span className="stat-label">Aktywny</span>
                </div>
              </div>
              <a href="https://discord.gg/Uxnr8GyjkK" className="btn-discord">
                Dołącz Teraz
              </a>
            </div>
          </div>

          <div className="social-grid">
            <a href="https://www.instagram.com/app.vroom/" className="social-card instagram-card">
              <div className="social-card-icon">
                <span className="material-icons">photo_camera</span>
              </div>
              <h4>INSTAGRAM</h4>
              <p>Zobacz co się u nas dzieje</p>
              <span className="follow-btn">Zobacz</span>
            </a>

            <a href="https://www.tiktok.com/@vroom.app" className="social-card tiktok-card">
              <div className="social-card-icon">
                <span className="material-icons">music_note</span>
              </div>
              <h4>TIKTOK</h4>
              <p>Zobacz co się u nas dzieje</p>
              <span className="follow-btn">Zobacz</span>
            </a>

            <a
              href="https://www.youtube.com/@V-ROOMAPP"
              className="social-card youtube-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-card-icon">
                <span className="material-icons">smart_display</span>
              </div>
              <h4>YOUTUBE</h4>
              <p>Oglądaj nasze filmy i relacje</p>
              <span className="follow-btn">Zobacz</span>
            </a>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="features" className="features-mega-section">
        <div className="section-title">
          <h2>
            FUNKCJE <span>APLIKACJI</span>
          </h2>
          <p>Wszystko co potrzebujesz na asfalcie</p>
        </div>
        <div className="features-showcase">
          <div className="phone-slider-container">
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="screen-slider" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {appScreens.map((src, i) => (
                  <img key={i} src={src} alt={`Screen ${i}`} className="screen-img" />
                ))}
              </div>
              <div className="slider-dots">
                {appScreens.map((_, i) => (
                  <div key={i} className={`dot ${currentSlide === i ? 'active' : ''}`} />
                ))}
              </div>
            </div>
            <div className="phone-glow"></div>
          </div>

          <div className="features-grid-side">
            {[
              { n: '01', icon: 'map', title: 'LIVE MAP', desc: 'Widzisz znajomych w realnym czasie na mapie.' },
              {
                n: '02',
                icon: 'military_tech',
                title: 'WYZWANIA & QUESTY',
                desc: 'Codzienne misje i sezony. Zbieraj nagrody i osiągnięcia.',
              },
              { n: '03', icon: 'lock_open', title: 'ODBLOKOWUJ MIASTA', desc: 'Odwiedzasz miasto — odblokowujesz % na mapie.' },
              { n: '04', icon: 'directions_car', title: 'PROFIL & GARAŻ', desc: 'Zarządzaj profilem, dodawaj auta z prawdziwego życia.' },
              { n: '05', icon: 'people', title: 'SPOTY SPOŁECZNOŚCI', desc: 'Fajne miejsca dodawane przez społeczność na mapie!' },
              { n: '06', icon: 'trending_up', title: 'PEŁNE STATYSTYKI', desc: 'Prędkość, kilometry, punkty i poziom gracza.' },
            ].map((f) => (
              <div key={f.n} className="feature-item">
                <div className="feature-number">{f.n}</div>
                <div className="feature-content">
                  <span className="material-icons">{f.icon}</span>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* RANKING */}
      <section id="ranking" className="ranking-section">
        <div className="section-title">
          <h2>
            RANKING <span>NAJLEPSZYCH</span>
          </h2>
          <p>Sprawdź kto jest najlepszy w globalnym rankingu</p>
          <p style={{ color: '#e33835', fontSize: '0.8rem', marginTop: 8 }}>[RANKING AKTYWNY PRZY PREMIERZE APLIKACJI]</p>
        </div>
        <div className="ranking-container">
          <div className="podium-stage">
            <div className="podium-position pos-2">
              <div className="podium-card">
                <div className="rank-crown">👑</div>
                <div className="player-name">DriftQueen</div>
                <div className="player-value">11.230</div>
              </div>
              <div className="podium-step step-2">2</div>
            </div>
            <div className="podium-position pos-1">
              <div className="podium-card main">
                <div className="rank-crown main-crown">👑</div>
                <div className="player-name">Speaking</div>
                <div className="player-value">12.458</div>
              </div>
              <div className="podium-step step-1">1</div>
            </div>
            <div className="podium-position pos-3">
              <div className="podium-card">
                <div className="rank-crown">👑</div>
                <div className="player-name">TurboMax</div>
                <div className="player-value">10.102</div>
              </div>
              <div className="podium-step step-3">3</div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer-v2">
        <div className="f-top">
          <div className="f-brand">
            VROOM<span>.</span>
          </div>
          <div className="f-socials">
            <a href="https://www.instagram.com/app.vroom/" target="_blank" rel="noopener noreferrer" className="s-circle">
              IG
            </a>
            <a href="https://discord.gg/Uxnr8GyjkK" target="_blank" rel="noopener noreferrer" className="s-circle">
              DS
            </a>
            <a href="https://www.youtube.com/@V-ROOMAPP" target="_blank" rel="noopener noreferrer" className="s-circle">
              YT
            </a>
          </div>
        </div>
        <div className="f-bottom">
          <p>&copy; 2026 VROOM.APP. MADE FOR THOSE WHO NEVER STOP.</p>
          <div style={{ marginTop: 8, display: 'flex', gap: 16, justifyContent: 'center' }}>
            <button className="link-btn" onClick={onShowTerms}>
              Regulamin
            </button>
            <button className="link-btn" onClick={onShowPrivacy}>
              Polityka Prywatności
            </button>
          </div>
        </div>
      </footer>

      {/* AUTH MODAL — przekazuje kod ref */}
      {showAuth && (
        <AuthModal onClose={() => setShowAuth(false)} onLogin={handleLoginSuccess} defaultReferralCode={refCode} />
      )}
    </div>
  );
}